import { isStaleChunkError, recoverFromStaleBuild } from "./appVersion";

/**
 * Catches a bare `import()` whose rejection nobody handled. Installed at module scope in
 * main.tsx, outside React, so the error boundary can't unmount it.
 *
 * Deliberately not listening for `vite:preloadError`: calling preventDefault() on it makes
 * Vite resolve the import with undefined, so lazyWithRecovery never sees the failure and
 * React crashes on "reading 'default'".
 */
export const handleStaleChunkRejection = (event: PromiseRejectionEvent): void => {
  if (!isStaleChunkError(event.reason)) return;
  event.preventDefault();
  void recoverFromStaleBuild();
};

let isInstalled = false;

export const installStaleBuildRecovery = (): void => {
  if (isInstalled) return;
  window.addEventListener("unhandledrejection", handleStaleChunkRejection);
  isInstalled = true;
};
